import { render, staticRenderFns } from "./codeExplain.vue?vue&type=template&id=cd84cc32&scoped=true"
import script from "./codeExplain.vue?vue&type=script&lang=js"
export * from "./codeExplain.vue?vue&type=script&lang=js"
import style0 from "./codeExplain.vue?vue&type=style&index=0&id=cd84cc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd84cc32",
  null
  
)

export default component.exports